/**
 * Get or set a CSS variable
 *
 * @param name
 * @param value
 */
export default function (name, value) {
    let propertyName;

    if (name.substr(0, 2) !== '--') {
        propertyName = `--${name}`;
    }

    if (value) {
        document.documentElement.style.setProperty(propertyName, value);
    }

    return getComputedStyle(document.documentElement).getPropertyValue(propertyName);
}
